export default __webpack_public_path__ + "static/media/contact-4k.01fe44ac.jpg";